/* eslint-disable sort-imports */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { withRouter } from '~HOC';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { changeLanguage } from '../../actions/language';
import { updateUser } from '../../../src/actions/user';
import { profileRoutes } from '../../utils/consts/routes';
import { StackHolder, Toast } from '../../component';
import { jwtApi, profileApi } from '../../services/apis';
import { SignOutClearStore } from '../../utils/clearData';
import worldImage from '../../content/images/weatherAndWorld/World-Map.png';
import { setToken } from '../../actions/requestToken';
import {
  ShoppingBagIcon,
  UserCogIcon,
  UserIdBadgeIcon,
  HeadsetIcon,
  CoinIcon,
  UserReportIcon,
  CustomerClubIcon,
  DashboardIcon,
  UserTieIcon,
  LogoutIcon,
  GatewayIcon,
} from '~svg';
import '../../domain/profile/profile/ribbon.scss';
import './ProfileSideBar.scss';

//پروقایل حقوقی
const business = [
  {
    isLock: false,
    label: <FormattedMessage id="profile.dashboard" />,
    id: 'DASHBOARD',
    name: 'DASHBOARD',
    link: profileRoutes.dashboard,
    iconName: <DashboardIcon size={24} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.businessprofile" />,
    name: 'EDITPROFILE',
    link: profileRoutes.businessProfile,
    iconName: <UserTieIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.employeeManagement" />,
    name: 'EMPLOYEEMANAGEMENET',
    link: profileRoutes.employeeManagement,
    iconName: <UserReportIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.customerManagement" />,
    name: 'CUSTOMERMANAGEMENT',
    link: profileRoutes.customerManagement,
    iconName: <UserCogIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.onlinesupport" />,
    id: 'ONLINESUPPORT',
    name: 'ONLINESUPPORT',
    link: profileRoutes.ticket,
    iconName: <HeadsetIcon size={22} color="#80c494" variant="mx-1" />,
  },

  {
    label: <FormattedMessage id="footer.customerClub" />,
    id: 'COMMISSION',
    name: 'COMMISSION',
    link: profileRoutes.commissionManagement,
    iconName: <CustomerClubIcon size={22} color="#80c494" variant="mx-1" />,
  },
  // {
  //   label: <FormattedMessage id="profile.departmentmanagement" />,
  //   name: "PROFILEDEPARTMENT",
  //   link: profileRoutes.profileDepartment,
  // },
  {
    label: <FormattedMessage id="profile.businessbooking" />,
    name: 'BUSINESSBOOKING',
    link: profileRoutes.bookingFlights,
    iconName: <ShoppingBagIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.financialmanagement" />,
    id: 'FinancialManagement',
    name: 'FinancialManagement',
    link: profileRoutes.financialManagement,
    iconName: <CoinIcon size={22} color="#80c494" variant="mx-1" />,
  },

  // {
  //   label: <FormattedMessage id="profile.creditmanagement" />,
  //   name: "MYCREDIT",
  //   link: profileRoutes.myCredit,
  //   iconName: "fa-trophy",
  // },
  // {
  //   label: <FormattedMessage id="profile.airlinequota" />,
  //   name: "AIRLINEQUOTA",
  //   link: profileRoutes.airlineQuota,
  // },
  // {
  //   label: <FormattedMessage id="profile.tourManagement" />,
  //   id: 'TOURMANAGEMENT',
  //   name: 'TOURMANAGEMENT',
  //   link: profileRoutes.tourManagement,
  //   iconName: <CoinIcon size={22} color="#80c494" variant="mx-1" />,
  // },
  {
    label: <FormattedMessage id="profile.gatewayroutes" />,
    id: 'GATEWAYS',
    name: 'GATEWAYS',
    link: profileRoutes.gateway,
    iconName: <GatewayIcon size={22} color="#80c494" variant="mx-1" />,
  },
  // {

  // {
  //   label: <FormattedMessage id="profile.saleaccounting" />,
  //   name: "PROFILEACCOUNTING",
  //   link: profileRoutes.accounting,
  //   iconName: "fa-badge-dollar",
  // },
];

const individual = [
  {
    isLock: false,
    label: <FormattedMessage id="profile.dashboard" />,
    id: 'DASHBOARD',
    name: 'DASHBOARD',
    link: profileRoutes.dashboard,
    iconName: <DashboardIcon size={24} color="#80c494" variant="mx-1" />,
  },
  {
    isLock: false,
    label: <FormattedMessage id="profile.profile" />,
    id: 'PROFILE',
    name: 'PROFILE',
    link: profileRoutes.userBasicInfo,
    iconName: <UserIdBadgeIcon size={24} color="#80c494" variant="mx-1" />,
  },
  {
    isLock: false,
    label: <FormattedMessage id="profile.onlinesupport" />,
    id: 'ONLINESUPPORT',
    name: 'ONLINESUPPORT',
    link: profileRoutes.ticket,
    iconName: <HeadsetIcon size={22} color="#80c494" variant="mx-1" />,
  },

  {
    label: <FormattedMessage id="footer.customerClub" />,
    id: 'COMMISSION',
    name: 'COMMISSION',
    link: profileRoutes.commissionManagement,
    iconName: <CustomerClubIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    isLock: false,
    label: <FormattedMessage id="profile.book/reserve" />,
    id: 'RESERVE',
    name: 'RESERVE',
    link: profileRoutes.bookingFlights,
    iconName: <ShoppingBagIcon size={22} color="#80c494" variant="mx-1" />,
  },
  {
    label: <FormattedMessage id="profile.financialmanagement" />,
    id: 'FinancialManagement',
    name: 'FinancialManagement',
    link: profileRoutes.financialManagement,
    iconName: <CoinIcon size={22} color="#80c494" variant="mx-1" />,
  },
];

const Logo = () => (
  <div className="bg--primary justify-content-center pb-1 pt-2 d-lg-none p-0 d-flex col-12">
    <img
      src={require('../../content/images/elements/logo.png')}
      className="col-4"
      style={{ height: 100 }}
      alt="logo"
    />
  </div>
);
const NavProfileMenuItem = ({
  direction,
  pathname,
  index,
  currenMenuItemIndex,
  item,
  handleClick,
}) => {
  return (
    <div
      key={index}
      className={` sideBarItems  bg-primary
                ${direction === 'rtl' ? 'pr-3' : 'pl-xl-3 pl-1'}
                ${
                  index === currenMenuItemIndex - 1 &&
                  pathname !== '/profile/edit-business-profile'
                    ? `selected-top-${direction} `
                    : ''
                }
                ${
                  pathname === '/profile/send-profile-for-verification' &&
                  'rounded-0'
                }
            ${
              index === currenMenuItemIndex + 1 &&
              pathname !== '/profile/edit-business-profile'
                ? `selected-bottom-${direction}`
                : ''
            }  `}
    >
      <div
        id={item.id}
        key={index}
        className={`d-flex border-0 align-items-center text-uppercase py-3 profile-menu pointer px-2
                    position-relative
                    ${
                      currenMenuItemIndex === index
                        ? // pathname.includes(item.link)
                          'text-primary font-xl-large font-normal font-weight-bold bg-third-light active px-0 border-0 selected'
                        : 'text-third '
                    }
            ${
              currenMenuItemIndex === index
                ? direction === 'ltr'
                  ? 'default-border-left-radius'
                  : 'default-border-right-radius'
                : ''
            }
                   `}
        onClick={() => {
          handleClick(item, index);
        }}
      >
        {item.iconName}

        <span
          className={`flex-fill text-start text-nowrap pt-1 text-capitalize ${
            direction === 'rtl'
              ? 'font-xxl-small font-msmall px-2 pt-1'
              : 'font-xxl-msmall font-xsmall px-xl-1 px-0 pt-0'
          }`}
        >
          {item.label}
        </span>
      </div>
    </div>
  );
};

const Logout = ({ direction, navigate }) => {
  let profileSidebar = JSON.parse(localStorage.getItem('profileSidebar'));
  return (
    <div
      className={` sideBarItems bg-primary px-3
    ${
      profileSidebar &&
      profileSidebar.currentIndex === profileSidebar.length - 1 &&
      `selected-bottom-${direction}`
    }`}
    >
      <Link
        className={`d-flex logOut
        align-items-center w-100 text-uppercase py-3 profile-menu pointer ${
          direction === 'rtl' ? 'px-2' : 'px-xl-2 px-0'
        } logOut-sidebar`}
        style={{}}
        to="/login"
        onClick={() => {
          try {
            jwtApi
              .signOut()
              .then((res) => {
                if (res.status === 200 && res.payload.data === 1) {
                  SignOutClearStore();
                  navigate('/');
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                SignOutClearStore();
                navigate('/');
              });
          } catch (error) {
            console.log(error);
            SignOutClearStore();
            navigate('/');
          }
        }}
      >
        <LogoutIcon size={24} color="#80c494" variant="px-1" />
        <span
          className={`flex-fill text-start text-capitalize font-xxl-msmall ${
            direction === 'rtl'
              ? 'font-msmall px-2 pt-1'
              : 'font-xsmall px-xl-1 px-0 pt-0'
          }`}
        >
          <FormattedMessage id="header.logout" />
        </span>
      </Link>
    </div>
  );
};
const Friends = ({ usersActivity }) => {
  return (
    <>
      {usersActivity.map((item, index) => (
        <img
          key={index}
          className=" d-flex align-self-center rounded-circle friend-img-size"
          src={item}
          alt="Friends"
        />
      ))}
    </>
  );
};
const DotMap = () => (
  <img
    src={worldImage}
    className="px-3 py-4"
    style={{ width: '16rem', height: '11rem' }}
    alt="worldImage"
  />
);

const profiles = {
  individual,
  business,
};
const ProfileSideBar = (props) => {
  const [currenMenuItemIndex, setCurrenMenuItemIndex] = useState(0);
  const [profiletype, setProfiletype] = useState();
  const [currentProfile, setCurrentProfile] = useState();
  const [toast, setToast] = useState(false);
  const [toastState, setToastState] = useState('success');
  const [alertMessage, setAlertMessage] = useState('profile.notallowed');
  useEffect(() => {
    if (props?.location?.pathname) {
      let index = profiles?.[profiletype]?.findIndex((item) =>
        props.location.pathname.includes(item.link),
      );
      setCurrenMenuItemIndex(!index ? 0 : index < 0 ? 0 : index);
    }
  }, [props?.location?.pathname, profiletype]);

  const handleClick = (item, index) => {
    if (index !== currenMenuItemIndex) {
      try {
        if (item.name === 'SIGNOUT')
          jwtApi
            .signOut()
            .then((res) => {
              if (res.status === 200 && res.payload.data === 1) {
                SignOutClearStore();
                props.navigate('/');
              }
            })
            .catch((error) => {
              console.log('error', error);
            });

        if (item.id && item.name !== item.id)
          profileApi
            .activeProfile(item.id)
            .then((result) => {
              if (result.status === 200) {
                props.setToken(result?.payload?.data?.token || '');
                props.navigate(item.link);
              }
            })
            .catch((error) => {
              setAlertMessage('profile.notallowed');
              setToast(true);
              setToastState('danger');
            });
        if (item.name === item.id && item.name === 'RESERVE')
          profileApi
            .activeProfile(props.user.user[0].profileId)
            .then((result) => {
              if (result.status === 200) {
                props.setToken(result?.payload?.data?.token || '');
                props.navigate(item.link);
              }
            })
            .catch((error) => {
              setAlertMessage('profile.notallowed');
              setToast(true);
              setToastState('danger');
            });
        props.navigate(item.link);
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <div
      id="profile-sidebar"
      className="profile-sidebar d-flex flex-column flex-grow-1 bg-third-light"
      style={{ backgroundColor: '#25282d' }}
    >
      <Toast
        isOpen={toast}
        onClose={() => this.setState({ toast: false })}
        state={toastState}
        position="bottom"
        message={props.intl.formatMessage({
          id: alertMessage,
        })}
        direction={props.language.directio}
      />
      <div className="d-none p-0 rounded-bottom ">
        <Logo />
      </div>
      <div className="mt-0 flex-grow-1 d-lg-flex d-none flex-column p-0 bg-third-light">
        <div
          className={`w-100 d-flex flex-column p-3 text-white  align-items-start justify-content-center bg-primary border-bottom border-primary-light`}
        >
          <div className="w-100 d-flex">
            <div className="rounded-circle d-flex justift-content-center align-items-center logo-profile">
              <img
                className="rounded-circle bg-primary p-1 w-100 h-100"
                src={
                  currentProfile?.image
                    ? currentProfile?.image
                    : require('../../content/images/avatars/1.png')
                }
                alt=""
              />
            </div>
            <div className="col- px-0 d-flex align-items-center font-xl-msmall font-lg-xsmall font-normal px-1 text-truncate">
              <span className="text-truncate">
                {`${props?.user?.user?.[0]?.firstName} ${props?.user?.user?.[0]?.lastName}`}
              </span>
            </div>
          </div>
          <div className="d-flex flex-column align-items-start w-100 py-2">
            <StackHolder
              userData={props?.user}
              onChange={(selectedProfieType, profileData, isUpdateprofile) => {
                if (!isUpdateprofile) {
                  setProfiletype(selectedProfieType);
                  setCurrentProfile(profileData);
                  let index = profiles?.[selectedProfieType]?.findIndex(
                    (item) => props.location.pathname.includes(item.link),
                  );
                  if (index < 0 && profileData) {
                    props.navigate(profileData.profileRoute);
                  } else {
                    props.navigate(props.location.pathname);
                  }
                } else {
                  setCurrentProfile(profileData);
                  setProfiletype(selectedProfieType);
                }
              }}
            />
          </div>
        </div>

        <a
          className="d-flex bg-primary d-lg-none align-items-center w-100 text-uppercase rounded-0 
        profile-menu pointer menu-mobile-flight-height px-2 text-white"
          href="/booking/select-city"
        >
          <FormattedMessage id="booking.searchflight" />
        </a>
        <div className="">
          {profiles?.[profiletype]?.map((item, mapIndex) => (
            <NavProfileMenuItem
              key={mapIndex}
              handleClick={handleClick}
              pathname={props.location.parse}
              direction={props.language.direction}
              item={item}
              index={mapIndex}
              currenMenuItemIndex={currenMenuItemIndex}
            />
          ))}
          <Logout
            direction={props.language.direction}
            navigate={props.navigate}
          />
        </div>

        <div className=" d-flex flex-column align-items-start bg-primary px-4 pb-4 pt-3 ">
          <span
            className={`text-secondary-light ${
              props.language.direction === 'rtl'
                ? 'font-small'
                : 'font-xl-small font-msmall'
            }`}
          >
            <FormattedMessage id="profile.onlineFriend" />
          </span>
          <div
            className={`usersActivity d-flex justify-content-start align-items-center w-100 pt-3 ${
              props.language.direction === 'rtl' ? 'pr-3' : 'pl-0'
            }`}
          >
            <Friends
              usersActivity={[
                require('../../content/images/avatars/profileUser.png'),
                require('../../content/images/avatars/profileUser.png'),
                require('../../content/images/avatars/profileUser.png'),
                require('../../content/images/avatars/profileUser.png'),
              ]}
            />
            <div
              className="text-white rounded-circle flex-column friend-img-size bg-secondary-light d-flex align-items-center justify-content-center font-xsmall p-2 "
              style={{ marginRight: -15 }}
            >
              <div className="">20+</div>
              <FormattedMessage id="booking.person" />
            </div>
          </div>
        </div>
        <div className="bg-primary flex-fill d-flex align-items-center justify-content-center">
          <DotMap />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    language: state.language,
    isMobile: state.profileReducer.isMobile,
    user: state?.user?.userInfo,
  };
}
export default withRouter(
  injectIntl(
    connect(mapStateToProps, {
      changeLanguage,
      updateUser,
      setToken,
    })(ProfileSideBar),
  ),
);
